/** חברת Funner הפנימית — פיצ'רים שמוצגים רק אצלנו, לא אצל לקוחות. */
export const FUNNER_INTERNAL_COMPANY_ID = (
  import.meta.env.VITE_APP_FUNNER_COMPANY_ID ?? '07b9f2b0-dba8-486b-89bd-4d20246c7798'
).toLowerCase();

export function isFunnerInternalCompany(companyId: string | null | undefined): boolean {
  return Boolean(companyId && companyId.toLowerCase() === FUNNER_INTERNAL_COMPANY_ID);
}

export function collectCompanyIdCandidates(
  userCompanyId?: string | null,
  companyId?: string | null,
  storedCompanyId?: string | null,
): string[] {
  return [userCompanyId, companyId, storedCompanyId].filter(Boolean) as string[];
}
